import { ResetPasswordFormData } from "./types";

export function getResetPasswordFormDataInitialValues(): ResetPasswordFormData {
  return {
    password: '',
    passwordRepeated: '',
  };
}
